/**
 * 全局加载占位组件
 * 用于 React Suspense 的 fallback 场景
 */
export function LoadingFallback() {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-50">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
    </div>
  );
}